var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopBar',{attrs:{"folded":_vm.topBar !== 'expanded',"hidden":_vm.topBar === 'hidden'}}),_c('router-view'),_c('Drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }